
// CACHES
import Filestores_cache from './Filestores.js';

export default [
	Filestores_cache
];
